import { createEntityAdapter } from '@reduxjs/toolkit';
import type { EntityValue } from './generatedReportsTypes';

const reportsAdapter = createEntityAdapter<EntityValue, string>({
  selectId: (entity) => entity.location,
});

export default reportsAdapter;
